var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { REJECT_RECHARGE_REQUEST, rejectRechargeSuccess, rejectRechargeFailure } from "../../actions";
import APIIN from "@/utils/APIIN";
const onRejectRecharge = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.post(`pmnt/admin/wallet/recharge/${action.payload.requestId}/reject`, { reason: action.payload.reason })
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* rejectRechargeWorker(action) {
    var _a, _b, _c;
    try {
        const data = yield call(onRejectRecharge, action);
        yield put(rejectRechargeSuccess(data));
    }
    catch (error) {
        yield put(rejectRechargeFailure(((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.messages) === null || _c === void 0 ? void 0 : _c[0]) || (error === null || error === void 0 ? void 0 : error.message)));
    }
}
export function* watchRejectRecharge() {
    yield takeLatest(REJECT_RECHARGE_REQUEST, rejectRechargeWorker);
}
